import { CalculatedValue } from '../../../model/calculated-value';
import { ClientEvaluatedFactor } from '../../../model/client-model/client-evaluated-factor';
import { ClientParameter } from '../../../model/client-model/client-parameter';

export function isClientParameter(
  parameter: ClientParameter | ClientEvaluatedFactor | CalculatedValue
): parameter is ClientParameter {
  return 'name' in parameter;
}
